<template>
  <div>
    <div style="margin-top: 60px;"><img src="../assets/xitoxq1.jpg" alt=""></div>
    <div style="flex-wrap: wrap;justify-content: center;display: flex;">
      <div><img src="https://www.tsintell.com/img/shaicha-1.jpg" alt=""></div>
      <div><img src="https://www.tsintell.com/img/shaicha-2.jpg" alt=""></div>
      <div style="justify-content: center;display: flex;"><img src="../assets/xitoshuzhutu1.jpg" alt="" style="width: 70%;"></div>
      <div class="innovation-features">
        <h2>创新特色</h2>
        <div class="feature-container">
          <!-- AI 预测模型 -->
          <div class="feature">
            <h3>AI 预测预警模型</h3>
            <ul>
              <li>近视统计数据集</li>
              <li>三级预警走势预测</li>
              <li>近视和趋势预测</li>
              <li>筛查工作完成情况明细</li>
              <li>各数据统计表完整</li>
            </ul>
          </div>
          <!-- 实时数据三级质控系统 -->
          <div class="feature">
            <h3>实时数据三级质控系统</h3>
            <ul>
              <li>指标逻辑调整</li>
              <li>近视预警预测</li>
              <li>AI 模型自动判断</li>
            </ul>
          </div>
          <!-- 大数据应用平台 -->
          <div class="feature">
            <h3>大数据应用平台</h3>
            <ul>
              <li>全校数据统计</li>
              <li>视力发布情况</li>
              <li>视力体检情况统计</li>
              <li>数据结果导出</li>
            </ul>
          </div>
        </div>
      </div>
      <div><img src="../assets/xitoshuzhutu.jpg" alt=""></div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
  components: {
    Footer
  }
}
</script>

<style>
.innovation-features {
  padding: 20px;
  text-align: center;
  font-family: Arial, sans-serif;
}

.feature-container {
  display: flex;
  justify-content: space-around;
  gap: 20px;
}

.feature {
  width: 30%;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.feature:hover {
  transform: translateY(-5px);
}

h2 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
}

h3 {
  font-size: 22px;
  margin-bottom: 15px;
  color: #007bff;
}

ul {
  list-style-type: none;
  padding: 0;
  text-align: left;
}

li {
  margin-bottom: 10px;
  color: #555;
  font-size: 16px;
}

@media (max-width: 768px) {
  .feature {
    width: 100%;
  }
}
</style>